import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import "../Home/components/Faq/faq.scss";
import Faq from "./components/FaqContainer/Faq";
import "../Home/components/Faq/i18n";
import { useTranslation } from "react-i18next";
import "./faq.scss";
import { pushFaqPageView } from "utils/dataLayer";

const FaqPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location?.search);
  const [initialQuestion] = useState(searchParams.get("question"));
  const [initialSection] = useState(searchParams.get("section"));
  const [initialSubSection] = useState(
    searchParams.get("subSection") || searchParams.get("subsection")
  );
  const userId = searchParams.get("userId") || "";
  const { t } = useTranslation();

  useEffect(() => {
    pushFaqPageView(userId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="faq-section-container">
      <div className="faq-section-container-row" id="faq-section">
        <div className="faq-container faq-section-container-col-xs-12 faq-section-container-col-sm-10 faq-section-container-col-offset-sm-1 faq-section-container-col-12">
          <div className="faq-mobile-title">
            <h3>{t("faq:title")}</h3>
            <p>{t("faq:help")}</p>
          </div>
          <Faq
            initialQuestion={
              initialQuestion ? parseInt(initialQuestion) : undefined
            }
            initialSection={
              initialSection ? parseInt(initialSection) : undefined
            }
            initialSubSection={
              initialSubSection ? parseInt(initialSubSection) : undefined
            }
          />
        </div>
      </div>
    </div>
  );
};

export default FaqPage;
